import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { NameSubForm, Schema as NameSchema } from '../subforms/Name';
import { PersonalDataSubForm, Schema as PersonalDataSchema } from '../subforms/PersonalData';
import { ContactSubForm, Schema as ContactSchema } from '../subforms/Contact';
import { AdditionalConsentSubForm, Schema as AdditionalConsentSchema } from '../subforms/AdditionalConsent';
import { DocumentsSubForm, Schema as DocumentsSchema } from '../subforms/Documents';
import { OtherInformationSubForm, Schema as OtherInformationSchema } from '../subforms/OtherInformation';

export const GSKNachwuchsSchema = (settings) => (
    Yup.object()
        .concat(PersonalDataSchema)
        .concat(NameSchema(settings))
        .concat(ContactSchema(settings))
        .concat(OtherInformationSchema)
        .concat(AdditionalConsentSchema)
        .concat(DocumentsSchema(settings))
);

export const GSKNachwuchs = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <Field component={PersonalDataSubForm} colors={colors} />
            <Field component={NameSubForm} colors={colors} settings={settings} />
            <Field component={ContactSubForm} colors={colors} settings={settings} />
            <Field component={OtherInformationSubForm} colors={colors} settings={settings} />
            <Field component={DocumentsSubForm} colors={colors} settings={settings} />
            <Field component={AdditionalConsentSubForm} colors={colors} settings={settings} />
        </>
    );
}